import { normalSanatizerBRL } from "src/utils/functions";
import { ResultCalculoINSS } from "../calcular-inss";
export const CalculadoraINSSTable = ({
    results
}: {
    results: ResultCalculoINSS
}) => {
    return (
        <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
            <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
                <thead className="bg-gray-200 sticky top-0">
                    <tr>
                        <th className="px-4 py-2 text-center truncate">Salário bruto</th>
                        <th className="px-4 py-2 text-center truncate">Alíquota Efetiva INSS (%)</th>
                        <th className="px-4 py-2 text-center truncate">INSS a descontar (R$)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.ValorBruto)}
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.Aliquota}%
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.ValorDescontado)}
                        </td>

                    </tr>

                </tbody>
            </table>

        </div >
    )
}